import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs';
import { cfetch } from '@confluence/network';

export async function fetchShortcutEnabledState(): Promise<boolean> {
	let enabled = false;
	let shard = '';

	try {
		let res;
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR && process.env.BIFROST_TEMPLATE_BUILD !== 'true') {
			shard = getSSRRenderInputs().shard ?? '';
			// cc-frontend-ssr won't match tenant host
			res = await cfetch(`https://${shard}/wiki/rest/confluenceshortcuts/latest/enabled`);
		} else {
			res = await cfetch('/wiki/rest/confluenceshortcuts/latest/enabled');
		}

		if (res.ok) {
			enabled = (await res.text()) === 'true';
		}
	} catch (e) {
		getMonitoringClient().submitError(
			new Error(`Error fetching keyboard shortcuts enabled state in shard ${shard}: ${e.message}`),
			{ attribution: Attribution.BACKBONE },
		);
	}

	return (window.__SHORTCUT_ENABLED__ = enabled);
}

export async function preloadShortcutEnabledState(): Promise<boolean> {
	const { isLoggedIn, isLicensed } = getPreloaderFnContext();
	if (isLoggedIn && isLicensed) {
		return await fetchShortcutEnabledState();
	}
	return false;
}
